// نقطة واحدة لعنوان الباك اند - كل خدمات التطبيق (src/store/services/**) لازم
// تستورد منها بدل ما تكتب الدومين صريح. قبل كده كان الدومين القديم
// (preelive.info) مكرر يدويًا في أكتر من 100 مكان في 20 ملف، فتغييره
// أو الرجوع لـ staging كان محتاج بحث واستبدال في كل الملفات دي.
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://lionchat.shop/public/api/v1";
